<mat-divider></mat-divider>
<h3 class="text-center p-3">&copy; 2021 by Michael Glenn, Parker Hoskovec, Troy Houston, Xianbin Zhen <br><span class="text-danger">Admin user: admin, Password: 1</span></h3>

